module.exports = __webpack_public_path__ + "media/images/more-dots-black-3a937fa2928f451f837318ae0cf0f26e.svg";